module.exports = __webpack_public_path__ + "media/images/contest/con-wait-icon-6d5156e378604ddf885faecf18c4c34e.svg";